import PropTypes from 'prop-types';
import { Box, Button, Menu } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { DynamicSubmenuItem } from './DynamicSubmenuItem';

/**
 * DynamicRaceNav Component
 * Renders the dynamic Camps & Races dropdown navigation button and menu per ADR 0005.
 * Displays active camps, races, and a disabled "No upcoming races" placeholder when no races are scheduled.
 */
export function DynamicRaceNav({
    item,
    index = 1,
    isOpen,
    anchorEl,
    onOpen,
    onClose,
    showTransparent,
    isItemRegistered
}) {
    if (!item) return null;

    const hasDivider = Boolean(item.submenu?.some(i => i.isDivider));

    return (
        <Box key={item.label}>
            <Button
                id={`nav-menu-button-${index}`}
                aria-controls={isOpen ? `nav-menu-${index}` : undefined}
                aria-haspopup="true"
                aria-expanded={isOpen}
                onClick={onOpen}
                endIcon={<ExpandMore sx={{ fontSize: '0.9rem !important' }} />}
                sx={{
                    color: showTransparent ? 'white' : 'text.primary',
                    fontWeight: 600,
                    fontSize: '0.825rem',
                    py: 0.5,
                    px: 1.25,
                    '&:hover': {
                        bgcolor: showTransparent
                            ? 'rgba(255,255,255,0.1)'
                            : 'rgba(0,0,0,0.04)',
                    },
                }}
            >
                {item.label}
            </Button>
            <Menu
                id={`nav-menu-${index}`}
                aria-labelledby={`nav-menu-button-${index}`}
                anchorEl={anchorEl}
                open={isOpen}
                onClose={onClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: 2,
                        mt: 1,
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                    },
                }}
            >
                {item.submenu?.map((subItem, subIndex) => (
                    <DynamicSubmenuItem
                        key={subItem.label || `submenu-${subIndex}`}
                        subItem={subItem}
                        subIndex={subIndex}
                        hasDivider={hasDivider}
                        onClose={onClose}
                        isItemRegistered={isItemRegistered}
                    />
                ))}
            </Menu>
        </Box>
    );
}

DynamicRaceNav.propTypes = {
    item: PropTypes.shape({
        label: PropTypes.string,
        submenu: PropTypes.arrayOf(PropTypes.object),
    }),
    index: PropTypes.number,
    isOpen: PropTypes.bool,
    anchorEl: PropTypes.any,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    showTransparent: PropTypes.bool,
    isItemRegistered: PropTypes.func,
};

export default DynamicRaceNav;
